(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/team-list-page/assets/javascripts/team-list-page.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/team-list-page/assets/javascripts/team-list-page.js');

'use strict';

const {
  WidgetArea
} = svs.components.lbUtils.widgetArea;
const {
  GameList
} = svs.components.marketplace.gameList;
const {
  TeamList: TeamListComponent
} = svs.components.marketplace.teamList;
const {
  CreateTeamButton
} = svs.marketplace.components.common;
const {
  DocumentTitle
} = svs.components.lbUtils;
const {
  useEffect,
  useRef,
  useCallback
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  selectors
} = svs.components.marketplaceData;
const {
  groupTypeNames
} = svs.components.marketplaceData.constants;
const {
  fetchNextRetailersAndTeamsAction
} = svs.components.marketplaceData.teams.actions;
const groupTypeFilter = groupTypeNames.PRIVATE;
const {
  initStates
} = svs.components.marketplaceData.constants;
const TeamListPage = () => {
  const dispatch = useDispatch();
  const loadDataRef = useRef(null);
  const intersectionObserver = useRef(null);
  const timeoutId = useRef(null);
  const {
    hasMoreData,
    nextLoading,
    loading,
    data
  } = useSelector(selectors.teams.getCustomerTeamsResult);
  const init = useRef(initStates.WAITING);
  const offset = useSelector(selectors.teams.selectCustomerTeamsOffset);
  const handleIntersect = useCallback(entries => {
    entries.forEach(entry => {
      const isIntersectingLoadDataRef = entry.target === loadDataRef.current && entry.isIntersecting;
      if (isIntersectingLoadDataRef && !nextLoading && hasMoreData) {
        intersectionObserver.current.unobserve(loadDataRef.current);
        dispatch(fetchNextRetailersAndTeamsAction({
          groupTypeFilter,
          offset
        }));
      }
    });
  }, [dispatch, hasMoreData, nextLoading]);
  useEffect(() => {
    if (init.current === initStates.WAITING) {
      init.current = initStates.ACTIVE;
      const onFetchResults = () => dispatch(fetchNextRetailersAndTeamsAction({
        groupTypeFilter,
        offset
      }));
      if (!(data !== null && data !== void 0 && data.length)) {
        onFetchResults();
      }
    } else if (init.current === initStates.ACTIVE && loading) {
      init.current = initStates.COMPLETE;
    } else if (init.current === initStates.COMPLETE && !loading) {
      init.current = initStates.READY;
    }
  }, [loading, data, dispatch]);
  useEffect(() => {
    intersectionObserver.current = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: [0, 0.5]
    });
    timeoutId.current = setTimeout(() => {
      loadDataRef.current && intersectionObserver.current.observe(loadDataRef.current);
    }, 200);
    return () => {
      if (intersectionObserver.current) {
        intersectionObserver.current.disconnect();
      }
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
        timeoutId.current = null;
      }
    };
  }, [handleIntersect, data]);
  return React.createElement(React.Fragment, null, React.createElement(DocumentTitle, {
    title: "Spela i lag - Spela tillsammans | Svenska Spel"
  }), React.createElement("div", {
    className: "marketplace-team-background marketplace-full-width"
  }, React.createElement("div", {
    className: "marketplace-width-limiter"
  }, React.createElement("h2", {
    className: "team-list-header f-medium f-800 margin-0"
  }, "Mina lag"), React.createElement("div", {
    className: "team-list padding-top-1",
    "data-testid": "qa-mkp-customer-teamlist"
  }, React.createElement(TeamListComponent, {
    maxGamesToDisplay: 3,
    shouldUseLastClicked: true,
    teamClassName: "team-listing margin-1"
  }, team => React.createElement(GameList, {
    className: "game-list-welcome",
    fromTeamList: true,
    gameLinkSearch: "returnUrl=/lag",
    groupId: team.id,
    hasBottomBorder: true,
    isListing: loading,
    maxGamesToDisplay: 3,
    noFetch: true
  })), React.createElement(CreateTeamButton, {
    className: "team-container margin-1"
  })), React.createElement("div", {
    className: "qa-fetch-more-data",
    ref: loadDataRef
  }, React.createElement("div", {
    className: "align-center"
  }, React.createElement("div", {
    className: "padding-1"
  }, hasMoreData && !loading ? 'Visar mer...' : '')))), React.createElement("div", {
    className: "marketplace-content-wrapper"
  }, React.createElement(WidgetArea, {
    className: "marketplace-teams-widget-area",
    widgetArea: "teamsWidgetArea"
  }))));
};
setGlobal('svs.marketplace.components.teamListPage.TeamListPage', TeamListPage);

 })(window);